// extracted by mini-css-extract-plugin
export var bounce = "_jm-1";
export var generatingText = "_jm-6";
export var lightning = "_jm-4";
export var popup = "_jm-5";
export var progressBar = "_jm-7";
export var progressFill = "_jm-8";
export var progressShimmer = "_jm-9";
export var progressText = "_jm-a";
export var shimmer = "_jm-3";
export var uploadIcon = "_jm-0";
export var uploadingText = "_jm-2";